import { Ambiente } from '../../types';
import { ElegibilidadeSuporteAosEstudosConfig, Params } from './elegibilidade-suporte-aos-estudos.types';

const configDefault: ElegibilidadeSuporteAosEstudosConfig = {
  periodoMinimo: '2025.2',
  marca: ['wyden', 'estacio'],
  tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
  modalidade: ['TOTAL EAD', 'DIGITAL', 'PRESENCIAL', 'SEMIPRESENCIAL', 'FLEX'],
  codigoCurso: [],
  matricula: [],
  codigoDisciplina: [],
};

const configsPorAmbiente: Record<Ambiente, ElegibilidadeSuporteAosEstudosConfig> = {
  local: {
    ...configDefault,
    periodoMinimo: '2024.2',
  },
  dev: {
    ...configDefault,
    periodoMinimo: '2024.2',
  },
  hml: {
    ...configDefault,
    periodoMinimo: '2024.2',
  },
  prd: configDefault,
};

export const getElegibilidadeSuporteAosEstudosConfig = ({ ambiente }: Params): ElegibilidadeSuporteAosEstudosConfig =>
  configsPorAmbiente[ambiente];
